
<div class="fixed inset-y-0 w-32 max-lg:hidden lg:pt-2 lg:pl-2 lg:pb-2 lg:pr-2">
  <nav
    class="h-full overflow-y-auto bg-white shadow dark:lg:bg-zinc-950 lg:block ring-1 ring-zinc-200 dark:ring-white/5 rounded-lg">
    <div class="flex w-full flex-col items-center py-6">
      <div class="flex flex-shrink-0 items-center">
        <a routerLink="/" (click)="onSelectMenu(menus['trips'])">
          <img class="h-12 w-auto hidden dark:block"
            src="assets/images/branding/n-light-logo.png" alt="company" />
          <img class="h-12 w-auto dark:hidden"
            src="assets/images/branding/N-Logo.png" alt="company" />
        </a>
      </div>
      <div class="mt-6 w-full flex-1 space-y-1 px-2">
        <ng-container *ngFor="let menu of menus | keyvalue : sortMethod">
          <a routerLink="{{ getMenu(menu.value).subMenus && getMenu(menu.value).subMenus.length ? getMenu(menu.value).subMenus[0].url : getMenu(menu.value).url }}"
          (click)="onSelectMenu(menu.value)"
          [ngClass]="menu.key === (selectedMenu ? selectedMenu.key : '') ? 'bg-zinc-950/5 dark:bg-white/5 dark:hover:bg-white/5 text-zinc-950 dark:text-white' : 'hover:bg-zinc-950/5 dark:hover:bg-white/5 text-zinc-950 dark:text-white'"
          class="group w-full p-3 rounded-md flex flex-col items-center text-xs font-medium"
            >
            <span [ngClass]="menu.key === (selectedMenu ? selectedMenu.key : '') ? 'text-zinc-950 dark:text-white' : 'text-zinc-500 dark:text-zinc-400'"
          [innerHTML]="getMenu(menu.value).sanitizedIcon"
        ></span>
            <span class="mt-2">{{ getMenu(menu.value).title }}</span>
          </a>
        </ng-container>
      </div>
    </div>
  </nav>
</div>
<!--
  Mobile menu

-->

<nav *ngIf="isShowSmallScreenMenu" class="relative z-40" role="dialog" aria-modal="true">
  <div class="fixed inset-0 z-40 flex dark:bg-white/50 bg-zinc-950/50">
    <div class="relative flex w-full max-w-32 flex-1 flex-col bg-white dark:bg-zinc-950 pt-5 pb-4">
      <div class="flex flex-col flex-shrink-0 items-center gap-4 px-4 justify-center">
        <button type="button" class="flex h-12 w-12 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-white" (click)="toggleNav()">
          <svg class="h-6 w-6 text-nav-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <span class="sr-only">Close sidebar</span>
        </button>
        <a routerLink="/signups" (click)="onSelectMenu(menus['trips'])">
          <img class="h-12 w-auto hidden dark:block" src="assets/images/branding/n-light-logo.png" alt="company" />
          <img class="h-12 w-auto dark:hidden" src="assets/images/branding/n-logo.png" alt="company" />
        </a>
      </div>
      <div class="mt-5 h-0 flex-1 overflow-y-auto px-2">
        <nav class="flex h-full flex-col">
          <div class="space-y-1">
            <ng-container *ngFor="let menu of menus | keyvalue : sortMethod">
              <div>
                <!-- Main Menu Item -->
                <a routerLink="{{ getMenu(menu.value).url }}" (click)="onSelectMenu(menu.key)" 
                  [ngClass]="menu.key === selectedMenu ? 'bg-zinc-950/5 dark:bg-white/5 text-zinc-950 dark:text-white' : 'hover:bg-zinc-950/5 dark:hover:bg-white/5 text-zinc-950 dark:text-white'"
                  class="group w-full p-3 rounded-md flex flex-col items-center text-xs font-medium">
                  <span [innerHTML]="getMenu(menu.value).sanitizedIcon"></span>
                  <span class="mt-2">{{ getMenu(menu.value).title }}</span>
                </a>

                
            
            
                
                <ng-container *ngIf="selectedMenu.key === menu.key">
                  <div class="mt-2 space-y-1">
                    <a routerLink="{{ getMenu(item).url }}" *ngFor="let item of getMenu(menu.value).subMenus"
                      class="group w-full p-2 rounded-md flex items-center text-xs font-medium hover:bg-zinc-950/5 dark:hover:bg-white/5 text-zinc-950 dark:text-white">
                      <span class="h-1 w-1 bg-zinc-950 dark:bg-white rounded-full mr-2"></span> 
                      {{ item.title }}
                    </a>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            
          </div>
        </nav>
      </div>
    </div>
    <div class="w-14 flex-shrink-0" aria-hidden="true"></div>
  </div>
</nav>

